export default "__VITE_ASSET__9dc55b2a__"